import DamCustom from './dam-portal-custom'
import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'

// Portal page data - reset by resetPortalState on every login (see resetPortalStores),
// except serviceUrl: it carries the page the user came from through login
const defaultState = () => ({
  loading: false,
  header: {},
  footer: {},
  serviceData: {},
  serviceList: [],
  customerTypeList: [],
  searchData: {
    loading: false,
    org_id: 0,
    customer_type_id: 0,
    service_category_id: 0
  },
  agriObj: {
    hasDropdownLoaded: false,
    organizationProfileList: [],
    divisionList: [],
    districtList: [],
    upazilaList: [],
    marketList: [],
    measurementUnitList: [],
    infrastructureList: [],
    communicationLinkageList: [],
    designationOfProductList: [],
    vehicleList: [],
    commodityTypeList: [],
    commodityGroupList: [],
    commoditySubGroupList: [],
    commodityNameList: [],
    campaignTypeList: DamCustom.campaignTypeList,
    yearList: DamCustom.yearList,
    monthList: DamCustom.monthList,
    weekList: DamCustom.weekList,
    timePreiodList: DamCustom.timePreiodList,
    priceEntryTypeList: DamCustom.priceEntryTypeList,
    priceTypeList: DamCustom.priceTypeList,
    dayList: DamCustom.dayList
  },
  trainObj: {
    hasDropdownLoaded: false,
    trainingTypeList: [],
    trainingCategoryList: [],
    trainingTitleList: [],
    duplicateCertificateFeeList: [],
    guestHouseList: [],
    roomTypeList: [],
    roomRentList: [],
    roomTypeSetupList: [],
    roomRentSetupList: []
  },
  agriResearchObj: {
    hasDropdownLoaded: false,
    publicationTypeList: [],
    publicationTitleList: [],
    organizationProfileList: [],
    thematicAreaList: [],
    publicationContentAreaList: [],
    sectorList: [],
    subSectorList: []
  },
  seedsFertilizerhObj: {
    hasDropdownLoaded: false,
    CropTypeList: [],
    VarietyList: [],
    CropNameList: [],
    measurementUnitList: [],
    productionSeasonList: [],
    organizationList: [],
    gpOrganizationsList: [],
    seasonList: DamCustom.seasonList
  },
 commonObj: {
    hasDropdownLoaded: false,
    orgList: [],
    officeTypeList: [],
    officeList: [],
    fiscalYearList: [],
    designationList: [],
    gradeList: [],
    organizationProfileList: []
  },
  categoryList: [],
  orgList: [],
  faqList: [],
  newsList: [],
  noticeList: [],
  serviceUrl: {
    externalPanelServiceUrl: '',
    externalPanelCurrentServiceUrl: '',
    subsidyCircularId: 0
  }
})

const state = defaultState()

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations: Object.assign({}, mutations, {
    resetPortalState (state) {
      Object.assign(state, defaultState(), { serviceUrl: state.serviceUrl })
    }
  })
}
